import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("类别")]), _c("div", {
    staticClass: "list"
  }, [_c("div", {
    staticClass: "list-item"
  }, [_vm._l(_vm.list, function (tag, index) {
    return [index < 9 ? _c("el-tag", {
      key: index,
      attrs: {
        size: "medium",
        type: _vm.hasTag(tag.id) || "info"
      },
      on: {
        click: function click($event) {
          return _vm.selectTag(tag);
        }
      }
    }, [_vm._v(_vm._s(tag.name) + " ")]) : _vm._e()];
  })], 2), _c("div", {
    staticClass: "list-item"
  }, [_vm._l(_vm.list, function (tag, index) {
    return [index >= 9 && index < 15 ? _c("el-tag", {
      key: index,
      attrs: {
        size: "medium",
        type: _vm.hasTag(tag.id) || "info"
      },
      on: {
        click: function click($event) {
          return _vm.selectTag(tag);
        }
      }
    }, [_vm._v(_vm._s(tag.name) + " ")]) : _vm._e()];
  })], 2), _c("div", {
    staticClass: "list-item"
  }, [_vm._l(_vm.list, function (tag, index) {
    return [index >= 15 && index < 26 ? _c("el-tag", {
      key: index,
      attrs: {
        size: "medium",
        type: _vm.hasTag(tag.id) || "info"
      },
      on: {
        click: function click($event) {
          return _vm.selectTag(tag);
        }
      }
    }, [_vm._v(_vm._s(tag.name) + " ")]) : _vm._e()];
  })], 2), _c("div", {
    staticClass: "list-item"
  }, [_vm._l(_vm.list, function (tag, index) {
    return [index >= 26 && index < 30 ? _c("el-tag", {
      key: index,
      attrs: {
        size: "medium",
        type: _vm.hasTag(tag.id) || "info"
      },
      on: {
        click: function click($event) {
          return _vm.selectTag(tag);
        }
      }
    }, [_vm._v(_vm._s(tag.name) + " ")]) : _vm._e()];
  })], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };